import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import {
  Masonry,
  getSorting,
  SORTING_CHEAP,
  SORTING_EXPENSIVE,
  SORTING_NEW,
  TranslationDictionary
} from '@plandi/common'
import { components } from '@plandi/common/src/generated'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Skeleton from '@material-ui/lab/Skeleton'

import { EmptyContent, URLS } from 'src/common'
import { useProjectListUserFilters } from './project-list-user.param'
import { useProjectListUserStyles } from './project-list-user.styles'
import { ProjectCard, ProjectCardSkeleton } from '../common'

type ProjectListUserProps = {
  contact?: boolean
  projects?: components['schemas']['ProjectMarketResource'][]
  contactData?: components['schemas']['ProfileContactResource']
  isLoading?: boolean
  translate?: TranslationDictionary['data']
  locale: string
}

export const ProjectListUser: React.FC<ProjectListUserProps> = (props) => {
  const theme = useTheme()
  const classes = useProjectListUserStyles()
  const { sort, setProjectListUserFilters } = useProjectListUserFilters()

  const breakpointColsMasonry = {
    default: 3,
    [theme.breakpoints.values.xl]: 3,
    [theme.breakpoints.values.lg]: 2,
    [theme.breakpoints.values.sm]: 1
  }

  if (props.isLoading) {
    return (
      <>
        <Skeleton className={classes.sort} />
        <Masonry breakpointCols={breakpointColsMasonry}>
          {[...new Array(9)].map((_, i) => (
            <ProjectCardSkeleton key={i} />
          ))}
        </Masonry>
      </>
    )
  }

  if (!props.projects || !props.projects.length) {
    return (
      <EmptyContent
        message={props.translate?.['no-users-projects']}
        showButton
        buttonProps={{
          href: URLS.home,
          text: props.translate?.message
        }}
      />
    )
  }

  return (
    <>
      <TextField
        select
        value={sort ?? 'new'}
        onChange={(event) =>
          setProjectListUserFilters({
            sort: event.target.value as typeof sort
          })
        }
        fullWidth
        className={classes.sort}
      >
        {[SORTING_NEW, SORTING_CHEAP, SORTING_EXPENSIVE].map((key) => (
          <MenuItem key={key} value={key}>
            {getSorting(props.translate)[key]}
          </MenuItem>
        ))}
      </TextField>
      <Masonry breakpointCols={breakpointColsMasonry}>
        {props.projects?.map((project) => (
          <ProjectCard
            contact={props.contact}
            key={project.id}
            {...project}
            contactData={props.contactData}
            cover={project.cover?.url}
            translate={props.translate}
            locale={props.locale}
          />
        ))}
      </Masonry>
    </>
  )
}
